/** Extract a user-facing message from an axios/API error. */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (!err || typeof err !== 'object' || !('response' in err)) {
    return err instanceof Error && err.message ? err.message : fallback
  }
  const message = (err as { response?: { data?: { message?: string | string[] } } }).response
    ?.data?.message
  if (Array.isArray(message)) return message.join(', ')
  if (typeof message === 'string' && message.trim()) return message
  return err instanceof Error && err.message ? err.message : fallback
}
